import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getClearDataTourSteps({
	defaultStyles,
}: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'clear-flow-variables',
			selector: '[data-tour="clear-flow-variables"]',
			content: 'When checked, all flow variables will be replaced with an empty object',
		},
		{
			id: 'clear-record-variables',
			selector: '[data-tour="clear-record-variables"]',
			content: "When checked, all records' variables will be replaced with an empty object.",
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
